// extracted by mini-css-extract-plugin
module.exports = {"full":"full-module--full--2XWDS","top":"full-module--top--2u4Or","bottom":"full-module--bottom--3m-Kn"};